import React, { useRef, useEffect } from 'react';
import styles from './HeroSection.module.css';
import '../styles/theme.css';

function HeroSection() {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const play = () => v.play().catch(() => {});
    play();
    v.addEventListener('canplaythrough', play);
    return () => v.removeEventListener('canplaythrough', play);
  }, []);

  return (
    <section className={styles['hero']}>
      <video
        ref={videoRef}
        loop
        muted
        playsInline
        preload="auto"
        src="/videos/home1_720p.mp4"
        className={styles['hero-video']}
      />
      <div className={styles['hero-overlay']} aria-hidden="true" />

      <h1 className={styles['hero-title']}>
        Knowledge and<br />
        <span>Data Analytics </span>
        <em>for Policy<span className={styles['hero-period']}></span></em>
      </h1>

      <div className={styles['hero-card']}>
        <p>
          Blending <em>academic insight</em> and policy expertise to equip leaders
          and organisations with innovative solutions.
        </p>
      </div>
    </section>
  );
}

export default HeroSection;
